import ComposeComponentProps from './ComposeComponentProps';
import RecipientPanel from './RecipientPanel';
import SubjectLine from './SubjectLine';
import { observer } from 'mobx-react';
import InfoBar from 'owa-info-bar/lib/components/InfoBar';
import { InfoBarMessageViewState } from 'owa-info-bar/lib/schema/InfoBarMessageViewState';
import { ComposeControl } from 'owa-mail-compose-store';
import getInfoBarMessageViewState from 'owa-mail-compose-actions/lib/utils/getInfoBarMessageViewState';
import canModifyRecipients from 'owa-mail-compose-actions/lib/utils/canModifyRecipients';
import * as React from 'react';
import { getMailTipMessageViewStates } from 'owa-mail-tips';
import getMailTips from 'owa-mail-tips/lib/selectors/getMailTips';
import { getAllRecipients } from 'owa-mail-compose-actions/lib/utils/getAllRecipientsAsEmailAddressStrings';
import { MeetingDetails } from 'owa-meeting-message';
import getCurrentFromAddress from 'owa-mail-compose-actions/lib/utils/getFromAddressFromRecipientWell';
import onRemoveRecipientFromMailTip from 'owa-mail-compose-actions/lib/actions/onRemoveRecipientFromMailTip';
import onAccessibilityCheckerClickFromMailTip from 'owa-mail-compose-actions/lib/actions/onAccessibilityCheckerClickFromMailTip';

const styles = require('./ComposeTop.scss');
const classNames = require('classnames/bind').bind(styles);

export interface ComposeTopProps extends ComposeComponentProps {
    senderPersona?: JSX.Element;
}

const composeTopRecipientPanelFocusTargets: ComposeControl[] = [
    ComposeControl.RecipientWellTo,
    ComposeControl.RecipientWellCc,
    ComposeControl.RecipientWellBcc,
];

@observer
export default class ComposeTop extends React.Component<ComposeTopProps, {}> {
    private subjectLine: SubjectLine;
    private recipientPanel: RecipientPanel;

    public trySetFocus(controlToFocus: ComposeControl): void {
        if (composeTopRecipientPanelFocusTargets.indexOf(controlToFocus) !== -1) {
            this.recipientPanel.focus(controlToFocus as (
                | ComposeControl.RecipientWellTo
                | ComposeControl.RecipientWellCc
                | ComposeControl.RecipientWellBcc));
        } else if (controlToFocus == ComposeControl.SubjectLine) {
            this.subjectLine.focus();
        }
    }

    render() {
        const { viewState, senderPersona } = this.props;
        const {
            infoBarIds,
            isInlineCompose,
            showCompactRecipientWell,
            fromViewState,
            ccRecipientWell,
            bccRecipientWell,
            meetingRequestItem,
        } = viewState;

        const containerClassName = classNames(styles.topContainer, {
            isInlineCompose: isInlineCompose,
        });

        const messages: InfoBarMessageViewState[] = [];

        for (const messageId of infoBarIds) {
            const message: InfoBarMessageViewState = getInfoBarMessageViewState(
                messageId,
                viewState
            );
            if (message) {
                messages.push(message);
            }
        }

        const fromAddress: string = getCurrentFromAddress(ccRecipientWell);

        const mailTipMessages = getMailTipMessageViewStates(
            getAllRecipients(viewState),
            getMailTips(),
            fromAddress,
            recipients => onRemoveRecipientFromMailTip(viewState, recipients),
            () => onAccessibilityCheckerClickFromMailTip(viewState)
        );

        return (
            <div className={containerClassName}>
                <InfoBar
                    messages={[...messages, ...mailTipMessages]}
                    textContainerClassName={styles.infoBarTextContainer}
                    className={styles.infoBar}
                />
                <RecipientPanel
                    isReadOnly={!canModifyRecipients(viewState)}
                    showCompactRecipientWell={showCompactRecipientWell}
                    isFromShown={fromViewState.isFromShown}
                    ccRecipientWell={ccRecipientWell}
                    bccRecipientWell={bccRecipientWell}
                    composeViewState={viewState}
                    onContentSizeChanged={this.onContentSizeChanged}
                    senderPersona={senderPersona}
                    ref={ref => (this.recipientPanel = ref)}
                />
                {!isInlineCompose && (
                    <SubjectLine
                        composeViewState={viewState}
                        ref={ref => (this.subjectLine = ref)}
                    />
                )}
                {meetingRequestItem && (
                    <div className={styles.meetingDetailsContainer}>
                        <MeetingDetails item={meetingRequestItem} isForward={true} />
                    </div>
                )}
            </div>
        );
    }

    private onContentSizeChanged = (delta: number, sourceElement: HTMLElement) => {
        if (this.props.plugins) {
            this.props.plugins.dockingPlugin.onContentSizeChanged(delta, sourceElement);
        }
    };
}
